import React, { useCallback } from 'react';

import { Popper, PopperProps } from 'embeds/components';
import { FilterChatActivityAssignees } from 'embeds/deprecated/queries';
import { actionChatActivityReassign } from 'embeds/sagas/sagaWatchersChatActivity';

import useReduxMutation, { UseReduxMutationConfig } from 'hooks/useReduxMutation';
import { fromGlobalId } from 'services/relayService';

export interface PopperChatActivityReassignProps extends Omit<PopperProps, 'classes' | 'children'> {
  chatActivityId: string;
  onClose: () => void;
  mutationConfig?: UseReduxMutationConfig;
}

const PopperChatActivityReassign: React.FC<PopperChatActivityReassignProps> = ({
  chatActivityId,
  onClose,
  mutationConfig,
  ...rest
}) => {
  // WORKAROUND use Redux typesafe-actions until we introduce GQL mutations
  const [execute] = useReduxMutation(actionChatActivityReassign);

  const handleNodeSelected = useCallback(
    (event: React.UIEvent | React.SyntheticEvent, node) => {
      event.preventDefault();
      event.stopPropagation();
      onClose();
      const { id: assigneeId } = fromGlobalId(node.id);
      execute({
        method: 'put',
        url: `/chatActivities/${chatActivityId}/assign/${assigneeId}`,
        ...mutationConfig,
      });
    },
    [chatActivityId, onClose, execute, mutationConfig],
  );

  return (
    <Popper data-lh-id="patient-actions-chat-activity-reassign-popper" {...rest}>
      <FilterChatActivityAssignees
        variables={{
          includeAvatar: true,
          includeChatActivityCount: true,
          filterChatActivityCount: { status: 'assigned' },
        }}
        includeSubheaders
        disablePadding
        onNodeSelected={handleNodeSelected}
      />
    </Popper>
  );
};

export default PopperChatActivityReassign;
